export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./covid.vue?vue&type=template&id=33456b9c"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/covid/covid.vue?vue&type=template&id=33456b9c
// module id = YTb3
// module chunks = 0